import React from "react";
import { CaretRight } from "@phosphor-icons/react";
import { Link } from "react-router-dom";

const FilterBySegment = ({
  data,
  onHandleFilter,
  activeFilter,
  onHandleActiveFiler,
  onHandleFiler,
}) => {
  return (
    <div className="text-white mt-8">
      <h2 className="text-2xl bebas text-font">Filter By Category</h2>
      <div className="flex flex-col gap-y-1 mt-2">
        {data?.map(({ name, slug }, index) => (
          <Link
            onClick={() => {
              onHandleFilter("segment");
              onHandleActiveFiler(slug);
              onHandleFiler && onHandleFiler();
            }}
            to={`/products/${slug}`} // Navigates to the segment URL
            className={`text-start text-sm border-b border-font transition ease-in duration-300 hover:text-white pb-1 flex items-center gap-x-2 justify-between group ${
              activeFilter === slug ? "text-white" : "text-font"
            }`}
            key={index}
          >
            {name}
            <span
              className={`transition ease-in duration-300 ${
                activeFilter === slug
                  ? "opacity-100 translate-x-0"
                  : "translate-x-[-40%] opacity-0 group-hover:translate-x-0 group-hover:opacity-100"
              }`}
            >
              <CaretRight size={20} />
            </span>
          </Link>
        ))}
      </div>
    </div>
  );
};

export default FilterBySegment;
// import React from "react";
// import { CaretRight } from "@phosphor-icons/react";
// import { Link } from "react-router-dom";

// const FilterBySegment = ({
//   data,
//   onHandleFilter,
//   activeFilter,
//   onHandleActiveFiler,
//   onHandleFiler,
// }) => {
//   return (
//     <div className="text-white mb-14">
//       <h2 className="text-3xl bebas text-font">Filter By Category</h2>
//       <div className="flex flex-col gap-y-3 mt-4">
//         {data?.map(({ name, slug }, index) => (
//           <Link
//             onClick={() => {
//               onHandleFilter("segment");
//               onHandleActiveFiler(slug);
//               onHandleFiler();
//             }}
//             to={`/products/${slug}`} // Navigates to the segment URL
//             className={`text-start border-b border-font transition ease-in duration-300 hover:text-white pb-1 flex items-center gap-x-2 justify-between group ${
//               activeFilter === slug ? "text-white" : "text-font"
//             }`}
//             key={index}
//           >
//             {name}
//             <span
//               className={`transition ease-in duration-300 ${
//                 activeFilter === slug
//                   ? "opacity-100 translate-x-0"
//                   : "translate-x-[-40%] opacity-0 group-hover:translate-x-0 group-hover:opacity-100"
//               }`}
//             >
//               <CaretRight size={20} />
//             </span>
//           </Link>
//         ))}
//       </div>
//     </div>
//   );
// };

// export default FilterBySegment;
